import * as React from 'react';
import * as _ from 'underscore';
import * as $ from 'jquery';

import { IDragState, ISizeObj, EdgeOrientationType } from './Interfaces';

export type IOnDragStart = (e, orient: EdgeOrientationType, index: number, ignoreMinFix: boolean) => void;

function LayoutGridEdge(props: {
    orientation: EdgeOrientationType;
    index: number;
    shift: number;
    showEdge: boolean;
    onDragStart: IOnDragStart;
}) {
    const [showCursor, setShowCursor] = React.useState(props.showEdge || props.orientation === 'vertical');

    const getHandlerMouseDown = () => {
        return (e) => {
            if (typeof props.onDragStart !== 'function') {
                return;
            }

            props.onDragStart(e, props.orientation, props.index, !e.shiftKey);

            e.stopPropagation();
            e.preventDefault();
        };
    };

    const handleOnMouseOver = (e) => {
        if (props.orientation !== 'horizontal') {
            return;
        }

        if (props.showEdge) {
            if (!showCursor) {
                setShowCursor(true);
            }
            return;
        }

        const elements = document.elementsFromPoint(e.clientX, e.clientY);

        if (elements != null) {
            const controlPanelIndex = elements.findIndex((element) => {
                return element.className.indexOf('widget-control-panel') >= 0;
            });

            if (controlPanelIndex < 0) {
                if (showCursor) {
                    setShowCursor(false);
                }
            } else {
                if (!showCursor) {
                    setShowCursor(true);
                }
            }
        }
    };

    const style: React.CSSProperties = {
        zIndex: 10
    };
    const dragHandlerStyle: React.CSSProperties = {};

    let className: string;

    if (props.orientation === 'vertical') {
        style.left = props.shift;
        className = 'vertical';
        dragHandlerStyle.cursor = 'ew-resize';
    } else {
        style.top = props.shift;
        className = 'horizontal';

        if (showCursor) {
            dragHandlerStyle.cursor = 'ns-resize';
        }
    }

    return (
        <div
            className={'layout-edge ' + className}
            style={style}
            onMouseDown={getHandlerMouseDown()}
            onTouchStart={getHandlerMouseDown()}
            onMouseOver={handleOnMouseOver}
        >
            <div className="drag-handler" style={dragHandlerStyle} />
            {props.showEdge ? <div className="visible-edge"></div> : null}
        </div>
    );
}

export function LayoutGridEdges(props: {
    orientation: EdgeOrientationType;
    sizes: ISizeObj[];
    dragState: IDragState;
    parentLeft: number;
    showGrid: boolean;
    onDragStart: IOnDragStart;
}) {
    const result: React.JSX.Element[] = [];
    const { orientation, showGrid } = props;
    const { drag, dragIndex, dragOrient, dragStartY, dragX, dragY } = props.dragState;
    const parentLeft = props.parentLeft ?? 0;

    let shift = 0;

    props.sizes.forEach((obj, index) => {
        let edgeShift = (shift += obj.size);

        if (drag && dragIndex === index && orientation === dragOrient) {
            if (orientation === 'vertical') {
                edgeShift = dragX - parentLeft;
            } else {
                edgeShift += dragY - dragStartY;
            }
        }

        if (showGrid || obj.origin.allowResize) {
            result.push(
                <LayoutGridEdge
                    key={orientation + '_' + index}
                    orientation={orientation}
                    index={index}
                    shift={edgeShift}
                    showEdge={showGrid}
                    onDragStart={props.onDragStart}
                />
            );
        }
    });

    return result;
}
